import { Base } from '@studiometa/js-toolkit';

/**
 * Header component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    refs: ['menuBtn'],
  };

  /**
   * Mount Header
   * @returns {void}
   */
  mounted() {
    this.body = document.querySelector('body');
  }

  /**
   * Open/Close menu
   * @returns {void}
   */
  onMenuBtnClick() {
    this.body.classList.toggle('menuIsOpen');
  }
}
